export const state = {
  areaList: [
    {
      url: '/facility-search',
      option_list: '指定しない',
    },
    {
      url: '/facility-search',
      option_list: '現在地周辺',
      text: '現在地周辺',
    },
    {
      url: '/facility-prefecture',
      option_list: '北海道',
    },
    {
      url: '/facility-prefecture',
      option_list: '東北',
    },
    {
      url: '/facility-prefecture',
      option_list: '関東甲信越',
    },
    {
      url: '/facility-prefecture',
      option_list: '東海・北陸',
    },
    {
      url: '/facility-prefecture',
      option_list: '近畿',
    },
    {
      url: '/facility-prefecture',
      option_list: '中国',
    },
    {
      url: '/facility-prefecture',
      option_list: '四国',
    },
    {
      url: '/facility-prefecture',
      option_list: '九州・沖縄',
    },
  ],
  prefectureList: [
    {
      url: '/',
      area: '',
      option_list: 'エリアから探す',
      text: '戻る',
    },
    {
      url: '/prefecture',
      area: 'すべて',
      option_list: '全域',
    },
    {
      url: '/prefecture',
      area: '北海道',
      option_list: '北海道',
    },
    {
      url: '/prefecture',
      area: '東北',
      option_list: '青森県',
    },
    {
      url: '/prefecture',
      area: '東北',
      option_list: '岩手県',
    },
    {
      url: '/prefecture',
      area: '東北',
      option_list: '宮城県',
    },
    {
      url: '/prefecture',
      area: '東北',
      option_list: '秋田県',
    },
    {
      url: '/prefecture',
      area: '東北',
      option_list: '山形県',
    },
    {
      url: '/prefecture',
      area: '東北',
      option_list: '福島県',
    },
    {
      url: '/prefecture',
      area: '関東甲信越',
      option_list: '茨城県',
    },
    {
      url: '/prefecture',
      area: '関東甲信越',
      option_list: '栃木県',
    },
    {
      url: '/prefecture',
      area: '関東甲信越',
      option_list: '群馬県',
    },
    {
      url: '/prefecture',
      area: '関東甲信越',
      option_list: '埼玉県',
    },
    {
      url: '/prefecture',
      area: '関東甲信越',
      option_list: '千葉県',
    },
    {
      url: '/prefecture',
      area: '関東甲信越',
      option_list: '東京都',
    },
    {
      url: '/prefecture',
      area: '関東甲信越',
      option_list: '神奈川県',
    },
    {
      url: '/prefecture',
      area: '関東甲信越',
      option_list: '新潟県',
    },
    {
      url: '/prefecture',
      area: '関東甲信越',
      option_list: '山梨県',
    },
    {
      url: '/prefecture',
      area: '関東甲信越',
      option_list: '長野県',
    },
    {
      url: '/prefecture',
      area: '東海・北陸',
      option_list: '富山県',
    },
    {
      url: '/prefecture',
      area: '東海・北陸',
      option_list: '石川県',
    },
    {
      url: '/prefecture',
      area: '東海・北陸',
      option_list: '福井県',
    },
    {
      url: '/prefecture',
      area: '東海・北陸',
      option_list: '岐阜県',
    },
    {
      url: '/prefecture',
      area: '東海・北陸',
      option_list: '静岡県',
    },
    {
      url: '/prefecture',
      area: '東海・北陸',
      option_list: '愛知県',
    },
    {
      url: '/prefecture',
      area: '東海・北陸',
      option_list: '三重県',
    },
    {
      url: '/prefecture',
      area: '近畿',
      option_list: '滋賀県',
    },
    {
      url: '/prefecture',
      area: '近畿',
      option_list: '京都府',
    },
    {
      url: '/prefecture',
      area: '近畿',
      option_list: '大阪府',
    },
    {
      url: '/prefecture',
      area: '近畿',
      option_list: '兵庫県',
    },
    {
      url: '/prefecture',
      area: '近畿',
      option_list: '奈良県',
    },
    {
      url: '/prefecture',
      area: '近畿',
      option_list: '和歌山県',
    },
    {
      url: '/prefecture',
      area: '中国',
      option_list: '鳥取県',
    },

    {
      url: '/prefecture',
      area: '中国',
      option_list: '島根県',
    },
    {
      url: '/prefecture',
      area: '中国',
      option_list: '岡山県',
    },
    {
      url: '/prefecture',
      area: '中国',
      option_list: '広島県',
    },
    {
      url: '/prefecture',
      area: '中国',
      option_list: '山口県',
    },
    {
      url: '/prefecture',
      area: '四国',
      option_list: '徳島県',
    },
    {
      url: '/prefecture',
      area: '四国',
      option_list: '香川県',
    },
    {
      url: '/prefecture',
      area: '四国',
      option_list: '愛媛県',
    },
    {
      url: '/prefecture',
      area: '四国',
      option_list: '高知県',
    },
    {
      url: '/prefecture',
      area: '九州・沖縄',
      option_list: '福岡県',
    },
    {
      url: '/prefecture',
      area: '九州・沖縄',
      option_list: '佐賀県',
    },
    {
      url: '/prefecture',
      area: '九州・沖縄',
      option_list: '長崎県',
    },
    {
      url: '/prefecture',
      area: '九州・沖縄',
      option_list: '熊本県',
    },
    {
      url: '/prefecture',
      area: '九州・沖縄',
      option_list: '大分県',
    },
    {
      url: '/prefecture',
      area: '九州・沖縄',
      option_list: '宮崎県',
    },
    {
      url: '/prefecture',
      area: '九州・沖縄',
      option_list: '鹿児島県',
    },
    {
      url: '/prefecture',
      area: '九州・沖縄',
      option_list: '沖縄県',
    },
  ],
  couponPrefectureList: [
    {
      url: '/coupon-list',
      prefecture_code: '1',
      option_list: '北海道',
    },
    {
      url: '/coupon-list',
      prefecture_code: '2',
      option_list: '青森県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '3',
      option_list: '岩手県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '4',
      option_list: '宮城県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '5',
      option_list: '秋田県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '6',
      option_list: '山形県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '7',
      option_list: '福島県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '8',
      option_list: '茨城県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '9',
      option_list: '栃木県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '10',
      option_list: '群馬県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '11',
      option_list: '埼玉県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '12',
      option_list: '千葉県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '13',
      option_list: '東京都',
    },
    {
      url: '/coupon-list',
      prefecture_code: '14',
      option_list: '神奈川県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '15',
      option_list: '新潟県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '16',
      option_list: '富山県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '17',
      option_list: '石川県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '18',
      option_list: '福井県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '19',
      option_list: '山梨県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '20',
      option_list: '長野県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '21',
      option_list: '岐阜県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '22',
      option_list: '静岡県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '23',
      option_list: '愛知県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '24',
      option_list: '三重県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '25',
      option_list: '滋賀県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '26',
      option_list: '京都府',
    },
    {
      url: '/coupon-list',
      prefecture_code: '27',
      option_list: '大阪府',
    },
    {
      url: '/coupon-list',
      prefecture_code: '28',
      option_list: '兵庫県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '29',
      option_list: '奈良県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '30',
      option_list: '和歌山県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '31',
      option_list: '鳥取県',
    },

    {
      url: '/coupon-list',
      prefecture_code: '32',
      option_list: '島根県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '33',
      option_list: '岡山県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '34',
      option_list: '広島県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '35',
      option_list: '山口県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '36',
      option_list: '徳島県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '37',
      option_list: '香川県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '38',
      option_list: '愛媛県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '39',
      option_list: '高知県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '40',
      option_list: '福岡県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '41',
      option_list: '佐賀県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '42',
      option_list: '長崎県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '43',
      option_list: '熊本県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '44',
      option_list: '大分県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '45',
      option_list: '宮崎県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '46',
      option_list: '鹿児島県',
    },
    {
      url: '/coupon-list',
      prefecture_code: '47',
      option_list: '沖縄県',
    },
  ],
}
